import React from 'react';
import {observer} from 'mobx-react';
import {ObjectSelect2, FormLayout, FormError} from 'shared/components';
import {withState, t} from 'shared/core';
import {Spinner} from 'shared/components';
import {SelectReviewersState} from '../state';
import {ModalButtons} from 'shared/components/modals';
import RevieweeSummary from './RevieweeSummary';
import _ from 'lodash';
import {FormattedMessage} from 'react-intl';

const LoadingState = observer(({isOpen, reviewee}) => {
  return (
    <div className='height-400'>
      <RevieweeSummary reviewee={reviewee}/>
      <Spinner/>
    </div>
  );
});

const SelectManagers = observer(({uiState}) => {
  return (
    <>
      <ObjectSelect2
        label='performance_reviews.manage.Manager reviewers'
        helpLink={{
          title: t('components.help_link.Who is this?'),
          explanation: {
            header: 'performance_reviews.manage.MANAGERS_HELP_HEADER',
            paragraphs: [
              t('performance_reviews.manage.MANAGERS_HELP_DESC_1'),
              t('performance_reviews.manage.MANAGERS_HELP_DESC_2'),
              t('performance_reviews.manage.MANAGERS_HELP_DESC_3')
            ]
          }
        }}
        multiple
        items={uiState.employeesWithReviewers}
        value={uiState.selectedManagers}
        onAdd={manager => uiState.addManagerReviewer(manager)}
        onRemove={manager => uiState.removeManagerReviewer(manager)}
        searchable
        allowClear
      />
      <div className='mt1'>
        <FormattedMessage id="performance_reviews.manage.All selected managers will be able to see each other's reviews." />
      </div>
    </>
  );
});

const SelectPeers = observer(({uiState}) => {
  if (!uiState.showPeerSelector) return null;

  return (
    <ObjectSelect2
      label='performance_reviews.manage.Peer reviewers'
      items={uiState.employeesWithReviewers}
      value={uiState.selectedPeers}
      onAdd={peer => uiState.addPeer(peer)}
      onRemove={peer => uiState.removePeer(peer)}
      placeholder='performance_reviews.manage.Add peer'
      multiple
    />
  );
});

const SelectReviewers = observer(({uiState}) => {
  const {errors} = uiState;
  return (
    <div>
      <FormLayout>
        <RevieweeSummary reviewee={uiState.reviewee}/>
        <SelectManagers uiState={uiState}/>
        <SelectPeers uiState={uiState}/>
        <FormError message={errors.base}/>
      </FormLayout>
      <ModalButtons onCancel={uiState.onHide} onSave={() => uiState.saveReviewers()}/>
    </div>
  );
});

export default withState(
  SelectReviewers,
  SelectReviewersState,
  {
    spinner: LoadingState
  }
);
